import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import './ReleaseNotes.css';

export default function ReleaseNotes() {
  const { userInfo } = useAuth();
  const [notes, setNotes] = useState([]);
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const token = sessionStorage.getItem('jwtToken');
  const isOwner = userInfo?.role === 'eigenaar';
  const load = useCallback(async () => {
    if (!isOwner) { setLoading(false); return; }
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/release-notes`, { headers: { Authorization: `Bearer ${token}` } });
      setNotes(response.data.data);
    } catch { setError('Releasenotes konden niet worden geladen.'); }
    finally { setLoading(false); }
  }, [token, isOwner]);
  useEffect(() => { load(); }, [load]);
  const publish = async event => {
    event.preventDefault(); if (saving || !isOwner) return;
    setSaving(true); setError(''); setMessage('');
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/release-notes`, { title: title.trim(), body: body.trim() }, { headers: { Authorization: `Bearer ${token}` } });
      setNotes(previous => [response.data.data, ...previous].slice(0,50)); setTitle(''); setBody('');
      setMessage('Gepubliceerd. Organisatie- en locatiebeheerders zien deze release bij hun volgende login.');
    } catch { setError('Publiceren mislukt. Je tekst is bewaard; probeer opnieuw.'); }
    finally { setSaving(false); }
  };
  if (!isOwner) return <div className="alert alert-danger">Geen toegang.</div>;
  return <div className="release-notes-page">
    <header className="rn-page-header">
      <div className="rn-page-icon" aria-hidden="true"><i className="bi bi-megaphone" /></div>
      <div><span className="rn-eyebrow">Updates voor beheerders</span><h1>Releasenotes</h1>
        <p>Vertel wat er nieuw is in Mijn Ouderapp.</p></div>
    </header>
    {error && <div className="alert alert-danger" role="alert">{error}</div>}
    {message && <div className="alert alert-success" role="status">{message}</div>}
    <div className="rn-layout">
      <section className="rn-panel" aria-labelledby="rn-compose-heading">
        <div className="rn-panel-heading"><h2 id="rn-compose-heading">Nieuwe release</h2>
          <p>Een korte, duidelijke update is genoeg.</p></div>
        <form onSubmit={publish} className="rn-compose">
          <div className="rn-field">
            <label htmlFor="release-title">Titel</label>
            <input id="release-title" className="form-control" placeholder="Bijvoorbeeld: Docentenuren aanpassen" value={title} onChange={e => setTitle(e.target.value)} maxLength={120} required disabled={saving} />
          </div>
          <div className="rn-field">
            <label htmlFor="release-body">Wat is er nieuw?</label>
            <textarea id="release-body" className="form-control" placeholder="Beschrijf kort wat er is verbeterd en wat beheerders ermee kunnen." rows={8} value={body} onChange={e => setBody(e.target.value)} maxLength={2000} required disabled={saving} aria-describedby="rn-body-help" />
            <div id="rn-body-help" className="rn-field-help"><span>Gebruik gewone tekst.</span><span>{body.length}/2000 tekens</span></div>
          </div>
          <div className="rn-audience"><i className="bi bi-info-circle" aria-hidden="true" /><p>Alle organisatie- en locatiebeheerders zien de nieuwste release één keer bij het inloggen.</p></div>
          <div className="rn-publish-footer"><span>Na publicatie blijft de tekst ongewijzigd.</span>
            <button className="btn btn-success" disabled={loading || saving || !title.trim() || !body.trim()}><i className="bi bi-send me-2" aria-hidden="true" />{saving ? 'Publiceren...' : 'Publiceren'}</button>
          </div>
        </form>
      </section>
      <section className="rn-history" aria-labelledby="rn-history-heading">
        <div className="rn-history-heading"><h2 id="rn-history-heading">Gepubliceerde releases</h2>{!loading && <span className="rn-count" aria-label={`${notes.length} gepubliceerde releases`}>{notes.length}</span>}</div>
        {loading ? <div className="rn-empty"><span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />Releasenotes laden...</div> : notes.length === 0 ? <div className="rn-empty"><i className="bi bi-clock-history" aria-hidden="true" /><p>Er zijn nog geen releasenotes.</p><small>Je eerste publicatie verschijnt hier.</small></div> : notes.map((note, index) => <article key={note.release_note_id} className="rn-release">
          <div className="rn-release-meta"><time dateTime={note.published_at}>{new Date(note.published_at).toLocaleString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</time>{index === 0 && <span className="rn-latest">Nieuwste</span>}</div>
          <h3>{note.title}</h3><div className="rn-release-body">{note.body}</div>
        </article>)}
      </section>
    </div>
  </div>;
}
